// src/components/common/ChartHeader/ChartHeader.jsx
import { Box, Stack, Typography } from "@mui/material";

const ChartHeader = ({ icon: Icon, title, action }) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      mb={2.5}
      width="100%"
    >
      <Stack direction="row" alignItems="center" gap={1}>
        {Icon && <Icon style={{ fill: "#002060" }} />}
        <Typography variant="body2" color="#002060" fontSize="1.3rem">
          {title}
        </Typography>
      </Stack>
      {action && <Box>{action}</Box>}
    </Stack>
  );
};

export default ChartHeader;
